import './DownloadButtons.css';

interface DownloadButtonsProps {
  appStoreUrl?: string;
  googlePlayUrl?: string;
  className?: string;
}

/**
 * Download buttons component for App Store and Google Play
 */
export function DownloadButtons({ 
  appStoreUrl = '#', 
  googlePlayUrl = '#',
  className = '' 
}: DownloadButtonsProps) {
  return (
    <div className={`download-buttons ${className}`}>
      <a
        href={appStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download on the App Store"
        className="download-button download-button-apple"
      >
        <img
          src="/app-store-badge.svg"
          alt="Download on the App Store"
          width="180"
          height="60"
          loading="lazy"
        />
      </a>
      <a
        href={googlePlayUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get it on Google Play"
        className="download-button download-button-google"
      >
        <img
          src="/google-play-badge.png"
          alt="Get it on Google Play"
          width="202"
          height="60"
          loading="lazy"
        />
      </a>
    </div>
  );
}

